export default "__VITE_ASSET__Cd7HHg_d__"